import { render, staticRenderFns } from "./info-tip.vue?vue&type=template&id=03207f9e&scoped=true&"
import script from "./info-tip.vue?vue&type=script&lang=ts&"
export * from "./info-tip.vue?vue&type=script&lang=ts&"
import style0 from "./info-tip.vue?vue&type=style&index=0&id=03207f9e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03207f9e",
  null
  
)

export default component.exports